var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6536 14.152C16.8773 13.341 15.4249 12.1211 15.4249 8.125C15.4249 5.08984 13.2359 2.66016 10.2844 2.06406V1.25C10.2844 0.559766 9.70908 0 8.99953 0C8.28997 0 7.71462 0.559766 7.71462 1.25V2.06406C4.7631 2.66016 2.57418 5.08984 2.57418 8.125C2.57418 12.1211 1.12173 13.341 0.345476 14.152C0.104405 14.4039 -0.00246943 14.7051 -0.000460502 15C0.00395913 15.6406 0.521056 16.25 1.28927 16.25H16.7098C17.478 16.25 17.9955 15.6406 17.9995 15C18.0015 14.7051 17.8946 14.4035 17.6536 14.152ZM2.71279 14.375C3.56538 13.2824 4.49752 11.4715 4.50194 8.14766C4.50194 8.13984 4.49953 8.13281 4.49953 8.125C4.49953 5.70859 6.51408 3.75 8.99953 3.75C11.485 3.75 13.4995 5.70859 13.4995 8.125C13.4995 8.13281 13.4971 8.13984 13.4971 8.14766C13.5015 11.4719 14.4337 13.2828 15.2863 14.375H2.71279ZM8.99953 20C10.4186 20 11.5697 18.8809 11.5697 17.5H6.42931C6.42931 18.8809 7.58042 20 8.99953 20Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.57892189.svg";
export { ForwardRef as ReactComponent };